import PropTypes from 'prop-types'
import { renderRoutes } from 'react-router-config'
import { GroupDialogProvider } from './contexts/GroupDialogContext'
import AddGroup from '../groupV4/dialogs/AddGroup'
import DeleteGroup from '../groupV4/dialogs/DeleteGroup'
import EditNameGroup from '../groupV4/dialogs/EditNameGroup'
import EditNameSubGroup from '../groupV4/dialogs/EditNameSubGroup'
import AddSubgroup from '../groupV4/dialogs/AddSubgroup'
import DeleteSubGroup from '../groupV4/dialogs/DeleteSubGroup'
import DeleteSubscriberFromGroup from '../groupV4/dialogs/DeleteSubscriberFromGroup'
import AddSubscriberToSubGroup from '../groupV4/dialogs/AddSubscriberToSubGroup'
import GroupLimitWarning from './dialogs/GroupLimitWarning'

const Group = (props) => (
  <GroupDialogProvider>
    {renderRoutes(props.route.routes)}
    <AddGroup />
    <DeleteGroup />
    <EditNameGroup />
    <EditNameSubGroup />
    <AddSubgroup />
    <DeleteSubGroup />
    <DeleteSubscriberFromGroup />
    <AddSubscriberToSubGroup />
    <GroupLimitWarning />
  </GroupDialogProvider>
)

Group.propTypes = {
  route: PropTypes.any,
  history: PropTypes.any,
  location: PropTypes.any,
}

export default Group
